import { styled } from "@mui/material";
import clsx from "clsx";

const ContainerStyled = styled("div")({
  display: "flex",
  flexDirection: "column",
});

const CardSection = ({ children, className }) => {
  return (
    <ContainerStyled className={clsx("card-section", className)}>
      {children}
    </ContainerStyled>
  );
};

export default CardSection;
